/**
 * Active entry: functional login page.
 * Legacy class: ./LogIn.js
 */
import LogInPage from "./LogInPage";

export default LogInPage;
